import { AssetCommonMaxWidth } from '@pkg/types';
import { type YatPageItemResponse } from '@pkg/types/api/requests';

import { type ContentItem, ContentType, type LinkContent, type NFTContent } from '@app/store/types/yat-page-actions';

import { getMashedUrl } from '../mediaMasher';

import { processPageMeta } from './processPageMeta';

export function processPageItem(item: YatPageItemResponse): ContentItem | undefined {
    const baseContentItem = {
        id: item.item_id || item.id,
        order: item.item_order || 0,
        draftOrder: item.draft_item_order || 0,
        layout: {
            isDraggable: true,
            moved: false,
            static: false,
        },
        editing: false,
        categories: [],
        collapsed: item.item_type.Link?.collapsed || false,
        collection_id: item.yat_page_collection_id,
        hasPersisted: true,
        published: !!item.published_at,
    };

    if (item.item_type.Link != null) {
        const meta = processPageMeta(item);
        const { title, url, description, page_preview } = item.item_type.Link;
        const content: LinkContent = {
            title,
            url,
            description,
            image: page_preview?.image || meta?.image || undefined,
        };

        return {
            ...baseContentItem,
            content: content,
            type: ContentType.LINK,
        };
    }

    if (item.item_type.Nft != null) {
        const { floor_price, image, name, animation_url, mime_type, ...rest } = item.item_type.Nft;

        const processedImage = getMashedUrl({ url: image, width: AssetCommonMaxWidth.Nft });
        const processedVideo = getMashedUrl({ url: animation_url, width: AssetCommonMaxWidth.Nft });

        const content: NFTContent = {
            fallbackAssetUrl: animation_url || image,
            floorPrice: {
                symbol: 'eth',
                value: floor_price,
            },
            floor_price,
            image: processedImage,
            mime_type,
            name,
            title: name,
            video: processedVideo,
            ...rest,
        };

        return {
            ...baseContentItem,
            content: content,
            type: ContentType.NFT,
        };
    }

    // eslint-disable-next-line no-console
    console.error('Item not supported', item);

    return;
}
